import axios from "axios";
import { apiUrl } from "../constant";

const API_BASE = `${apiUrl}/api/CarrierAccount`;

const getCarrierAccountsService = () => {
  return axios.get(`${API_BASE}/Accounts`);
};

const getAvailableCarriersService = () => {
  return axios.get(`${API_BASE}/Carriers`);
};

const connectCarrierAccountService = (carrierKey, payload) => {
  return axios.post(`${API_BASE}/Connect/${carrierKey}`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const disconnectCarrierAccountService = (accountId) => {
  return axios.delete(`${API_BASE}/Accounts/${accountId}`);
};

export const carrierAccountService = {
  getCarrierAccountsService,
  getAvailableCarriersService,
  connectCarrierAccountService,
  disconnectCarrierAccountService,
};
